import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
const bonuses = [{
  image: 'https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766517815/Bono_1_portada_-_checklist_bwom8l.png',
  title: 'BONO 1: Sistema Antirresbalones',
  value: '$27.95',
  description: 'Protocolo simple para evitar recaídas y recuperar el control sin culpa.',
  includes: ['Reinicio de 10 minutos', 'Mini-rutina para retomar', "Guía '48 horas para recuperar el control'"],
  result: 'Seguridad total para retomar siempre.'
}, {
  image: 'https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766517816/Bono_2_caratula_Antidoto_oo7xtb.png',
  title: 'BONO 2: Antídoto Contra la Culpa',
  value: '$19.97',
  description: 'Recupera paz mental aunque tu hogar no esté perfecto.',
  includes: ['Reprogramación emocional', 'Mantras de rescate', "Tarjeta 'no soy mi casa, soy mi paz'"],
  result: 'Liberarte de culpa y autoexigencia.'
}, {
  image: 'https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766517815/Bono_3_-_La_Compaera_q32bk6.png',
  title: 'BONO 3: La Compañera Invisible',
  value: '$21.97',
  description: 'Acompañamiento emocional diario para no sentirte sola.',
  includes: ['30 mensajes motivacionales', "Recordatorios 'no estás sola'", 'Guiones matutinos y nocturnos'],
  result: 'Sentirte guiada y acompañada.'
}];
export function BonusesSection() {
  return <Section background="gray" className="relative" data-id="element-8">
      <div className="text-center mb-16" data-id="element-9">
        <span className="inline-block px-4 py-1 bg-[#D4AF37]/20 text-[#9C7F22] font-bold rounded-full text-sm mb-4" data-id="element-10">
          SOLO POR HOY
        </span>
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4" data-id="element-11">
          Bonos Exclusivos <span className="text-[#FF6B6B]" data-id="element-12">(GRATIS)</span>
        </h2>
        <p className="text-xl text-gray-600" data-id="element-13">
          Valor total: <span className="line-through" data-id="element-14">$69.89</span> — incluidos
          SIN costo adicional.
        </p>
      </div>

      {/* Sistema Antirresbalones Visual */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto mb-16" data-id="element-15">
        <img src="https://cdn.magicpatterns.com/uploads/7eCcoiveecH3QiuCUwgidT/5.webp" alt="Siempre puedes retomar sin culpa - Sistema Antirresbalones" className="w-full h-auto rounded-2xl shadow-xl" loading="lazy" data-id="element-16" />
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-17">
        {bonuses.map((bonus, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.2
      }} className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 flex flex-col h-full relative overflow-hidden group hover:shadow-2xl transition-all duration-300" data-id="element-18">
            <div className="absolute top-0 right-0 bg-[#FF6B6B] text-white text-xs font-bold px-3 py-1 rounded-bl-lg z-10" data-id="element-19">
              GRATIS
            </div>

            {/* Book Cover Image */}
            <div className="relative mb-6 -mx-6 -mt-6" data-id="element-20">
              <motion.img src={bonus.image} alt={bonus.title} className="w-full h-auto rounded-t-2xl" loading="lazy" whileHover={{
            scale: 1.02
          }} transition={{
            duration: 0.3
          }} data-id="element-21" />
            </div>

            <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-22">
              {bonus.title}
            </h3>
            <p className="text-[#2C7A7B] font-bold mb-4" data-id="element-23">
              Valor: {bonus.value}
            </p>

            <p className="text-gray-600 mb-6 text-sm flex-grow" data-id="element-24">
              {bonus.description}
            </p>

            <div className="bg-gray-50 p-4 rounded-lg mb-4" data-id="element-25">
              <p className="text-xs font-bold text-gray-500 uppercase mb-2" data-id="element-26">
                Incluye:
              </p>
              <ul className="space-y-2" data-id="element-27">
                {bonus.includes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-28">
                    <span className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full mt-1.5 flex-shrink-0" data-id="element-29" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="pt-4 border-t border-gray-100" data-id="element-30">
              <p className="text-sm font-medium text-[#2C7A7B]" data-id="element-31">
                <span className="font-bold" data-id="element-32">Resultado:</span> {bonus.result}
              </p>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}